import { createFileRoute } from '@tanstack/react-router';

import { SiteTestimonialsPage } from '@/features/owner/site/SiteTestimonialsPage';

export const Route = createFileRoute('/_authed/owner/site/testimonials')({
  component: SiteTestimonialsPage,
});
